import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AdminPage } from "@/components/admin/AdminPage";
import { BrandingCard } from "@/components/admin/BrandingCard";
import { ProjectTypesCard } from "@/components/admin/ProjectTypesCard";
import { PrivacyRequestsCard } from "@/components/admin/PrivacyRequestsCard";
import { AuditLogCard } from "@/components/admin/AuditLogCard";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Gift, CreditCard } from "lucide-react";

function WorkspacePlanCard({ data }) {
  const planColor = {
    internal: "bg-violet-100 text-violet-700", enterprise: "bg-indigo-100 text-indigo-700",
    pro: "bg-blue-100 text-blue-700", starter: "bg-emerald-100 text-emerald-700", free: "bg-slate-100 text-slate-600",
  }[data.plan] || "bg-slate-100 text-slate-600";
  return (
    <Card className="p-6 border-slate-200" data-testid="workspace-plan-card">
      <div className="flex items-center gap-2">
        <CreditCard className="h-4 w-4 text-[#2563EB]" />
        <h3 className="text-sm font-semibold text-slate-900">Plan &amp; Billing</h3>
      </div>
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        <Badge className={`capitalize ${planColor}`}>{data.plan}</Badge>
        <Badge variant="outline" className="capitalize">{data.billing_status}</Badge>
        {data.complimentary && <Badge className="bg-amber-100 text-amber-700"><Gift className="h-3 w-3 mr-1" />Complimentary · €0</Badge>}
      </div>
      <p className="text-xs text-slate-500 mt-3">The plan is managed by the platform owner. Contact them to change it.</p>
    </Card>
  );
}

export default function AdminWorkspaceSettingsPage() {
  const [branding, setBranding] = useState(null);
  const [billing, setBilling] = useState(null);
  useEffect(() => {
    api.get("/branding").then((r) => setBranding(r.data)).catch(() => {});
    api.get("/workspace/billing").then((r) => setBilling(r.data)).catch(() => {});
  }, []);

  return (
    <AdminPage title="Workspace Settings" subtitle="Workspace-level configuration shared by all members. Personal preferences stay under each user's own settings." testid="admin-workspace-settings-page">
      {billing ? <WorkspacePlanCard data={billing} /> : null}
      {branding ? <BrandingCard data={branding} onSaved={setBranding} /> : <p className="text-slate-500">Loading…</p>}
      <ProjectTypesCard />
      <PrivacyRequestsCard />
      <AuditLogCard />
    </AdminPage>
  );
}
